import config from "../config";

export const auth = {
  en: {
    "auth.sign_up": "Sign Up",
    "auth.create_password": "Create a new password",
    "auth.create_password_text": "Please choose a new account password",
    "auth.new_password": "New password",
    "auth.confirm_password": "Confirm password",
    "auth.update_password": "Update password",
    "auth.enter_google_code": "Enter Google verification code",
    "auth.enter_sms_code": "Enter SMS verification code",
    "auth.enter_email_code": "Enter Email code",
    "auth.log_in": "Log in",
    "auth.first_time": `First time on ${config.default_title}?`,
    "auth.forgot_pass": "Forgot password?",
    "auth.reset_pass_title": "Password reset",
    "auth.reset_pass_text":
      "Please enter your email address to receive a password reset code",
    "auth.reset_pass": "Reset password",
    "auth.registration_completed": "Registration completed",
    "auth.registration_completed_t":
      "You have successfully created an account.",
    "auth.dashboard": "Go to Dashboard",
    "auth.create_acc": "Create account",
    "auth.sign_in": "Sign In",
    "auth.have_acc": "Already have an account?",
    "auth.requirements1": "The minimum password length is - 8 characters.",
    "auth.requirements2": "Contains both numbers and letters.",
    "auth.requirements3": "Special characters are allowed.",
    "auth.updated_pass": "Password updated!",
    "auth.updated_pass_t1": "Your password has been changed successfully.",
    "auth.updated_pass_t2": "Use your new password to log in.",
    "auth.agree_to": "I agree to the",
    "auth.terms": "Terms of Use",
    "auth.and": "and",
    "auth.p_p": "Privacy Policy",
    "auth.cookie_policy": "Cookie Policy",
    "auth.check_in_box1": "Check your inbox",
    "auth.check_in_box2_1": "An email has been sent to",
    "auth.check_in_box2_2":
      "Follow the link in the email to confirm your email.",
    "auth.welcomeBack": "Welcome Back",
    "auth.getStarted": "Get Started",
    "auth.signInWithGoogle": "Log in with Google",
    "auth.signUpWithGoogle": "Sign up with Google",
    "auth.letsGetStarted": "Lets",
    "auth.heyWelcomeBack": "Hey,",
    "auth.signInWithEmail": "Or, sign in with your email",
    "auth.signUpWithEmail": "Or, sign up with your email",
    "auth.signInWith": "Or, sign in with",
    "auth.signUpWith": "Or, sign up with",
    "auth.emailAddress": "Email",
    "auth.forgotPassword": "Forgot password?",
    "auth.signIn": "Sign In",
    "auth.alreadyHaveAccount": "Already registered?",
    "auth.agreeTerms": "I agree to the",
    "auth.passwordReset": "Password reset",
    "auth.passwordResetDesc":
      "Please enter your email address to receive a password reset code",
    "auth.rememberPassword": "Remember password?",
    "auth.rememberedPassword": "Remembered your password?",
    "auth.resetPassword": "Reset password",
    "auth.resetPasswordButton": "Reset Password",
    "auth.backToSignIn": "Back to Sign In",
    "auth.checkInbox": "Check Your Inbox",
    "auth.checkInboxDesc":
      "Follow to the link in the email to confirm your email",
    "auth.pleaseEnterValidEmail": "Please enter a valid email",
    "auth.passwordMinLength": "Password must be at least 8 characters",
    "auth.password": "Password",
    "auth.firstTime": "Not registered yet?",
    "auth.signUp": "Registration",
    "auth.signUpBtn": "Sign Up",
    "auth.logIn": "Log in",
    "auth.verify": "Verify",
    "auth.loading": "Loading...",
    "auth.user_not_found": "User doesn't exist",
    "auth.wrong_password_or_email": "Wrong email or password",
    "auth.invalid_code": "Invalid verification code",
    "auth.reset_link_expired_title": "Link expired",
    "auth.reset_link_expired_text":
      "This password reset link has expired or has already been used.",
    "auth.checking_reset_link": "Checking password reset link...",
    "auth.code_expired_or_used": "Code expired or already used",
    "auth.rememberMe": "Remember me",

    "auth.enter_confirmation_code": "Enter confirmation code",
    "auth.verification_code_sent": "We’ve sent a 6-digit verification code to",
    "auth.enter_code_below": "Please enter it below",
    "auth.did_not_receive_email": "Didn't get an email?",
    "auth.resend_code": "Resend code",
    "auth.resending_code": "Resending...",
    "auth.code_resent": "The code has been resent",
    "auth.issue_verifying_code": "Issue verifying code",
  },

  ru: {
    "auth.sign_up": "Регистрация",
    "auth.create_password": "Укажите пароль",
    "auth.create_password_text":
      "Пожалуйста, выберите новый пароль учетной записи",
    "auth.new_password": "Новый пароль",
    "auth.confirm_password": "Подтвердите пароль",
    "auth.update_password": " Обновите пароль",
    "auth.enter_google_code": "Введите код 2FA код с Вашего приложения, ",
    "auth.enter_sms_code": "Введите код с SMS",
    "auth.enter_email_code": "Введите код с e-mail",
    "auth.log_in": "Войти",
    "auth.first_time": `Впервые на ${config.default_title}?`,
    "auth.forgot_pass": "Забыли пароль?",
    "auth.reset_pass_title": "Восстановить пароль",
    "auth.reset_pass_text":
      "Пожалуйста, введите свой адрес e-mail, чтобы получить код сброса пароля",
    "auth.reset_pass": "Восстановить пароль",
    "auth.registration_completed": "Регистрация завершена",
    "auth.registration_completed_t": "Вы успешно создали учетную запись.",
    "auth.dashboard": "Войти в главное меню",
    "auth.create_acc": "Создать учетную запись",
    "auth.sign_in": "Войти",
    "auth.have_acc": "У вас уже есть аккаунт?",
    "auth.requirements1": "Минимальная длина пароля – 8 символов.",
    "auth.requirements2": "Должен содержать как цифры, так и буквы.",
    "auth.requirements3": "Допускаются специальные символы.",
    "auth.updated_pass": "Пароль успешно обновлен!",
    "auth.updated_pass_t1": "Ваш пароль был успешно изменен.",
    "auth.updated_pass_t2": "Для входа в систему используйте новый пароль.",
    "auth.agree_to": "Я согласен с",
    "auth.terms": "Условиями использования",
    "auth.and": "и",
    "auth.p_p": "Политикой конфиденциальности",
    "auth.cookie_policy": "Политикой использования файлов Cookie",
    "auth.check_in_box1": "Проверьте свой почтовый ящик",
    "auth.check_in_box2_1": "На ваш электронный адрес отправлено письмо",
    "auth.check_in_box2_2":
      "Перейдите по ссылке в письме, чтобы подтвердить свой адрес электронной почты.",
    "auth.welcomeBack": "С возвращением",
    "auth.getStarted": "Начать",
    "auth.signInWithGoogle": "Войти через Google",
    "auth.signUpWithGoogle": "Зарегистрироваться через Google",
    "auth.letsGetStarted": "Давайте",
    "auth.heyWelcomeBack": "Привет,",
    "auth.signInWithEmail": "Или войдите с помощью email",
    "auth.signUpWithEmail": "Или зарегистрируйтесь с помощью email",
    "auth.signInWith": "Или войдите с помощью",
    "auth.signUpWith": "Или зарегистрируйтесь с помощью",
    "auth.emailAddress": "Эл. почта",
    "auth.forgotPassword": "Забыли пароль?",
    "auth.signIn": "Войти",
    "auth.alreadyHaveAccount": "Уже зарегистрированы?",
    "auth.agreeTerms": "Я согласен с",
    "auth.passwordReset": "Сброс пароля",
    "auth.passwordResetDesc":
      "Пожалуйста, введите ваш адрес электронной почты, чтобы получить код сброса пароля",
    "auth.rememberPassword": "Помните пароль?",
    "auth.rememberedPassword": "Вспомнили пароль?",
    "auth.resetPassword": "Сбросить пароль",
    "auth.resetPasswordButton": "Сбросить пароль",
    "auth.backToSignIn": "Вернуться к входу",
    "auth.checkInbox": "Проверьте почту",
    "auth.checkInboxDesc":
      "Перейдите по ссылке в письме, чтобы подтвердить ваш email",
    "auth.pleaseEnterValidEmail": "Пожалуйста, введите действительный email",
    "auth.passwordMinLength": "Пароль должен содержать не менее 8 символов",
    "auth.password": "Пароль",
    "auth.firstTime": "Ещё не зарегистрированы?",
    "auth.signUp": "Регистрация",
    "auth.signUpBtn": "Регистрация",
    "auth.logIn": "Войти",
    "auth.verify": "Проверить",
    "auth.loading": "Загрузка...",
    "auth.user_not_found": "Пользователь не найден",
    "auth.wrong_password_or_email": "Неверный email или пароль",
    "auth.invalid_code": "Неверный код подтверждения",
    "auth.reset_link_expired_title": "Ссылка недействительна",
    "auth.reset_link_expired_text":
      "Ссылка для сброса пароля истекла или уже была использована.",
    "auth.checking_reset_link": "Проверяем ссылку для сброса пароля...",
    "auth.code_expired_or_used": "Код истек или уже был использован",
    "auth.rememberMe": "Запомнить меня",

    "auth.enter_confirmation_code": "Введите код подтверждения",
    "auth.verification_code_sent":
      "Мы отправили 6-значный код подтверждения на адрес",
    "auth.enter_code_below": "Введите его ниже",
    "auth.did_not_receive_email": "Не получили письмо?",
    "auth.resend_code": "Отправить код повторно",
    "auth.resending_code": "Отправка...",
    "auth.code_resent": "Код отправлен повторно",
    "auth.issue_verifying_code": "Ошибка при проверке кода",
  },

  es: {
    "auth.sign_up": "Registrarse",
    "auth.create_password": "Crear una nueva contraseña",
    "auth.create_password_text":
      "Por favor elige una nueva contraseña para tu cuenta",
    "auth.new_password": "Nueva contraseña",
    "auth.confirm_password": "Confirmar contraseña",
    "auth.update_password": "Actualizar contraseña",
    "auth.enter_google_code": "Introduce el código de verificación de Google",
    "auth.enter_sms_code": "Introduce el código de verificación por SMS",
    "auth.enter_email_code":
      "Introduce el código de verificación por correo electrónico",
    "auth.log_in": "Iniciar sesión",
    "auth.first_time": `¿Es la primera vez en ${config.default_title}?`,
    "auth.forgot_pass": "¿Olvidaste tu contraseña?",
    "auth.reset_pass_title": "Restablecer contraseña",
    "auth.reset_pass_text":
      "Por favor, introduce tu dirección de correo electrónico para recibir un código de restablecimiento de contraseña",
    "auth.reset_pass": "Restablecer contraseña",
    "auth.registration_completed": "Registro completado",
    "auth.registration_completed_t": "Has creado una cuenta exitosamente.",
    "auth.dashboard": "Ir al tablero",
    "auth.create_acc": "Crear cuenta",
    "auth.sign_in": "Iniciar sesión",
    "auth.have_acc": "¿Ya tienes una cuenta?",
    "auth.requirements1":
      "La longitud mínima de la contraseña es de 8 caracteres.",
    "auth.requirements2": "Debe contener números y letras.",
    "auth.requirements3": "Se permiten caracteres especiales.",
    "auth.updated_pass": "¡Contraseña actualizada!",
    "auth.updated_pass_t1": "Tu contraseña ha sido cambiada exitosamente.",
    "auth.updated_pass_t2": "Utiliza tu nueva contraseña para iniciar sesión.",
    "auth.agree_to": "Estoy de acuerdo con los",
    "auth.terms": "Términos de uso",
    "auth.and": "y",
    "auth.p_p": "Política de privacidad",
    "auth.cookie_policy": "Política de cookies",
    "auth.check_in_box1": "Revisa tu bandeja de entrada",
    "auth.check_in_box2_1": "Se ha enviado un correo electrónico a",
    "auth.check_in_box2_2":
      "Sigue el enlace en el correo electrónico para confirmar tu dirección de correo electrónico.",
    "auth.welcomeBack": "Bienvenido de nuevo",
    "auth.getStarted": "Comenzar",
    "auth.signInWithGoogle": "Iniciar sesión con Google",
    "auth.signUpWithGoogle": "Registrarse con Google",
    "auth.letsGetStarted": "Vamos a",
    "auth.heyWelcomeBack": "Hola,",
    "auth.signInWithEmail": "O inicia sesión con tu correo electrónico",
    "auth.signUpWithEmail": "O regístrate con tu correo electrónico",
    "auth.signInWith": "O inicia sesión con",
    "auth.signUpWith": "O regístrate con",
    "auth.emailAddress": "Correo electrónico",
    "auth.forgotPassword": "¿Olvidaste tu contraseña?",
    "auth.signIn": "Iniciar sesión",
    "auth.alreadyHaveAccount": "¿Ya estás registrado?",
    "auth.agreeTerms": "Estoy de acuerdo con",
    "auth.passwordReset": "Restablecer contraseña",
    "auth.passwordResetDesc":
      "Por favor, introduce tu dirección de correo electrónico para recibir un código de restablecimiento de contraseña",
    "auth.rememberPassword": "¿Recuerdas la contraseña?",
    "auth.rememberedPassword": "¿Recordaste tu contraseña?",
    "auth.resetPassword": "Restablecer contraseña",
    "auth.resetPasswordButton": "Restablecer contraseña",
    "auth.backToSignIn": "Volver a iniciar sesión",
    "auth.checkInbox": "Revisa tu bandeja de entrada",
    "auth.checkInboxDesc":
      "Sigue el enlace en el correo electrónico para confirmar tu correo electrónico",
    "auth.pleaseEnterValidEmail":
      "Por favor, introduce un correo electrónico válido",
    "auth.passwordMinLength": "La contraseña debe tener al menos 8 caracteres",
    "auth.password": "Contraseña",
    "auth.firstTime": "¿Aún no estás registrado?",
    "auth.signUp": "Registro",
    "auth.signUpBtn": "Registrarse",
    "auth.logIn": "Iniciar sesión",
    "auth.verify": "Comprobar",
    "auth.loading": "Cargando...",
    "auth.user_not_found": "El usuario no existe",
    "auth.wrong_password_or_email":
      "Correo electrónico o contraseña incorrectos",
    "auth.invalid_code": "Código de verificación inválido",
    "auth.reset_link_expired_title": "Enlace caducado",
    "auth.reset_link_expired_text":
      "Este enlace para restablecer la contraseña ha caducado o ya se ha utilizado.",
    "auth.checking_reset_link":
      "Comprobando el enlace de restablecimiento de contraseña...",
    "auth.code_expired_or_used": "El código ha caducado o ya se ha utilizado",
    "auth.rememberMe": "Recordarme",

    "auth.enter_confirmation_code": "Introduce el código de confirmación",
    "auth.verification_code_sent":
      "Hemos enviado un código de verificación de 6 dígitos a",
    "auth.enter_code_below": "Introdúcelo a continuación",
    "auth.did_not_receive_email": "¿No recibiste el correo electrónico?",
    "auth.resend_code": "Reenviar código",
    "auth.resending_code": "Reenviando...",
    "auth.code_resent": "El código se ha reenviado",
    "auth.issue_verifying_code": "Error al verificar el código",
  },

  ua: {
    "auth.sign_up": "Зареєструватися",
    "auth.create_password": "Створіть новий пароль",
    "auth.create_password_text":
      "Будь ласка, оберіть новий пароль для облікового запису",
    "auth.new_password": "Новий пароль",
    "auth.confirm_password": "Підтвердьте пароль",
    "auth.update_password": "Оновити пароль",
    "auth.enter_google_code": "Введіть код підтвердження Google",
    "auth.enter_sms_code": "Введіть код підтвердження SMS",
    "auth.enter_email_code": "Введіть код з Email",
    "auth.log_in": "Увійти",
    "auth.first_time": `Вперше на ${config.default_title}?`,
    "auth.forgot_pass": "Забули пароль?",
    "auth.reset_pass_title": "Скидання пароля",
    "auth.reset_pass_text":
      "Будь ласка, введіть вашу електронну адресу, щоб отримати код для скидання пароля",
    "auth.reset_pass": "Скинути пароль",
    "auth.registration_completed": "Реєстрацію завершено",
    "auth.registration_completed_t": "Ви успішно створили обліковий запис.",
    "auth.dashboard": "Перейти до панелі керування",
    "auth.create_acc": "Створити обліковий запис",
    "auth.sign_in": "Увійти",
    "auth.have_acc": "Вже маєте обліковий запис?",
    "auth.requirements1": "Мінімальна довжина пароля - 8 символів.",
    "auth.requirements2": "Містить як цифри, так і літери.",
    "auth.requirements3": "Дозволені спеціальні символи.",
    "auth.updated_pass": "Пароль оновлено!",
    "auth.updated_pass_t1": "Ваш пароль успішно змінено.",
    "auth.updated_pass_t2": "Використовуйте новий пароль для входу.",
    "auth.agree_to": "Я погоджуюсь з",
    "auth.terms": "Умовами користування",
    "auth.and": "та",
    "auth.p_p": "Політикою конфіденційності",
    "auth.cookie_policy": "Політикою використання cookie",
    "auth.check_in_box1": "Перевірте вашу поштову скриньку",
    "auth.check_in_box2_1": "Лист було надіслано на",
    "auth.check_in_box2_2":
      "Перейдіть за посиланням у листі, щоб підтвердити електронну адресу.",
    "auth.welcomeBack": "З Поверненням!",
    "auth.getStarted": "Створити Акаунт",
    "auth.signInWithGoogle": "Увійти через Google",
    "auth.signUpWithGoogle": "Зареєструватися через Google",
    "auth.letsGetStarted": "Давайте",
    "auth.heyWelcomeBack": "Привіт,",
    "auth.signInWithEmail": "Або через пошту",
    "auth.signUpWithEmail": "Або через пошту",
    "auth.signInWith": "Або через",
    "auth.signUpWith": "Або через",
    "auth.emailAddress": "Ел. пошта",
    "auth.forgotPassword": "Забули пароль?",
    "auth.signIn": "Увійти",
    "auth.alreadyHaveAccount": "Вже зареєстровані?",
    "auth.agreeTerms": "Я погоджуюсь з",
    "auth.passwordReset": "Скидання пароля",
    "auth.passwordResetDesc":
      "Будь ласка, введіть адресу електронної пошти, щоб отримати код скидання пароля",
    "auth.rememberPassword": "Пам'ятаєте пароль?",
    "auth.rememberedPassword": "Згадали свій пароль?",
    "auth.resetPassword": "Скинути пароль",
    "auth.resetPasswordButton": "Скинути пароль",
    "auth.backToSignIn": "Повернутися до Входу",
    "auth.checkInbox": "Перевірте Пошту",
    "auth.checkInboxDesc":
      "Перейдіть за посиланням у листі, щоб підтвердити свою електронну адресу та отримати пароль.",
    "auth.pleaseEnterValidEmail":
      "Будь ласка, введіть коректну електронну адресу",
    "auth.passwordMinLength": "Пароль має містити щонайменше 8 символів",
    "auth.password": "Пароль",
    "auth.firstTime": "Ще не зареєстровані?",
    "auth.signUp": "Реєстрація",
    "auth.signUpBtn": "Зареєструватися",
    "auth.logIn": "Увійти",
    "auth.verify": "Перевірити",
    "auth.loading": "Завантаження...",
    "auth.user_not_found": "Користувача не знайдено",
    "auth.wrong_password_or_email": "Невірна пошта або пароль",
    "auth.invalid_code": "Невірний код підтвердження",
    "auth.reset_link_expired_title": "Посилання недійсне",
    "auth.reset_link_expired_text":
      "Посилання для скидання пароля застаріло або вже було використане.",
    "auth.checking_reset_link": "Перевіряємо посилання для скидання пароля...",
    "auth.code_expired_or_used": "Код застарів або вже був використаний",
    "auth.rememberMe": "Запам'ятати мене",

    "auth.enter_confirmation_code": "Введіть код підтвердження",
    "auth.verification_code_sent":
      "Ми надіслали 6-значний код підтвердження на адресу",
    "auth.enter_code_below": "Введіть його нижче",
    "auth.did_not_receive_email": "Не отримали лист?",
    "auth.resend_code": "Надіслати код повторно",
    "auth.resending_code": "Надсилання...",
    "auth.code_resent": "Код надіслано повторно",
    "auth.issue_verifying_code": "Помилка під час перевірки коду",
  },
};

export default auth;
